export default {
  CouchURL: 'https://couchdb-0.datacompanysistemas.com',
  BackendURL: 'https://backup.datacompanysistemas.com/api',
  SocketURL: 'https://backup.datacompanysistemas.com',
  // BackendURL: 'http://localhost:3000/api',
  // SocketURL: 'http://localhost:3000',
}
